import * as LayoutCreatorEntities from '@bimser/components/dist/BCLayoutCreator/common/entities';
import { RuleEngineEntities } from '@bimser/components/dist/BCRuleManager';
import { Map } from 'immutable';
import { convertActionValue, getActionValue } from '../action';
import { IConditionTestItem } from './conditionTester';

export function convertConditions(
	condition: RuleEngineEntities.ICondition,
	formData: Map<string, LayoutCreatorEntities.LayoutItem>
): IConditionTestItem {
	if (condition.typeName === 'ConfirmationCondition') return;

	const fieldFact = [condition.field.name, condition.field.propertyName].join('.');

	let value;

	if (condition.typeName === 'ValueEntryCondition') {
		value = condition.value;
	} else if (
		condition.typeName === 'FieldSelectionCondition' &&
		condition.operation !== 'Null' &&
		condition.operation !== 'NotNull'
	) {
		const controlName = condition.selectedField.name;
		const propKey = condition.selectedField.propertyName;

		const actionValue = getActionValue(controlName, propKey, formData);
		value = convertActionValue(
			condition.selectedField,
			actionValue,
			formData,
			propKey.split('.'),
			true
		).value;
	}

	return {
		fact: fieldFact,
		operator: condition.operation,
		value
	};
}
